﻿export var mapBoundsSthlm:google.maps.LatLngBounds = new google.maps.LatLngBounds(
    new google.maps.LatLng(58.82796120145642, 16.76513671875),
    new google.maps.LatLng(59.94950917225228, 19.2425537109375)
);

export var defaultInitialMidPoint:google.maps.LatLng = new google.maps.LatLng(59.3320088, 18.0277143); // stockholm

var defaultMapOptions:google.maps.MapOptions = {
    zoom: 8,
    center: defaultInitialMidPoint,
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    panControl: false,
    zoomControl: true,
    mapTypeControl: true,
    scaleControl: true,
    streetViewControl: false,
    overviewMapControl: false,
    zoomControlOptions: {
        style: google.maps.ZoomControlStyle.SMALL,
        position: google.maps.ControlPosition.TOP_LEFT
    },
    mapTypeControlOptions: {
        style: google.maps.MapTypeControlStyle.DROPDOWN_MENU,
        position: google.maps.ControlPosition.TOP_LEFT
    }
};

export function markerImage(color:string) : any {
    return {
        path: 'M 0,0 C -2,-20 -10,-22 -10,-30 A 10,10 0 1,1 10,-30 C 10,-22 2,-20 0,0 z M -2,-30 a 2,2 0 1,1 4,0 2,2 0 1,1 -4,0',
        fillColor: color,
        fillOpacity: 1,
        strokeColor: "#000000",
        strokeWeight: 1,
        scale: 1,
    };
}

export var markerImageDefault = markerImage("#cc0000");
export var markerImageRed     = markerImage("#cc0000");
export var markerImageBlue    = markerImage("#0000cc");

export function markerCircle(color:string) : any {
    return {
        path: google.maps.SymbolPath.CIRCLE,
        fillColor: color,
        fillOpacity: 0.5,
        strokeColor: color,
        strokeWeight: 2,
        scale: 8,
    };
}

export var markerCircleDefault = markerCircle("#cc0000");
export var markerCircleRed     = markerCircle("#cc0000");
export var markerCircleBlue    = markerCircle("#0000cc");

export interface IMapOptions {
    [mapId:string] : google.maps.MapOptions;
}

export interface IMapMarkerArray {
    [mapId:string] : google.maps.Marker[];
}

export interface IMapMarkerBounds {
    [mapId:string] : google.maps.LatLngBounds;
}

var mapOptions:IMapOptions = {};
var mapMarkers:IMapMarkerArray = {};
var mapMarkerBounds:IMapMarkerBounds = {};

export interface IInitMapOptions {
    mapElement  : JQuery;
    mapId       : string;
    mapOptions? : google.maps.MapOptions;
}

export function initMap(options:IInitMapOptions) : google.maps.Map {
    options.mapOptions = <google.maps.MapOptions> $.extend(true, {}, defaultMapOptions, options.mapOptions);

    mapOptions[options.mapId] = options.mapOptions;
    mapMarkers[options.mapId] = [];
    mapMarkerBounds[options.mapId] = new google.maps.LatLngBounds();

    if (options.mapOptions.center === null) options.mapOptions.center = defaultInitialMidPoint;

    console.log("center: " + options.mapOptions.center);
    console.log("defaultcenter: " + defaultInitialMidPoint);
    console.log("mapElement: " + options.mapElement);
    console.log("mapElement: " + options.mapElement.get(0));

    return new google.maps.Map(
        options.mapElement.get(0),
        options.mapOptions
    );
}

export interface IAddMarkerOptions {
    map?     : google.maps.Map;
    mapId    : string;
    title?   : string;
    no       : number;
    image    : google.maps.MarkerImage;
    location : google.maps.LatLng;
    onClick? : any;
    onOver?  : any;
    onOut?   : any;
}

export function addMarker(options: IAddMarkerOptions) {
    var marker = new google.maps.Marker({
        icon: options.image,
        position: options.location,
        title: options.title,
        zIndex: options.no //,
        //animation: google.maps.Animation.DROP
    });

    if (options.map) marker.setMap(options.map);

    if (options.onClick) {
        google.maps.event.addDomListener(
            marker,
            "click",
            function () {
                options.onClick(this);
            }
        );
    }

    if (options.onOver) {
        google.maps.event.addDomListener(
            marker,
            "mouseover",
            function () {
                options.onOver(this);
            }
        );
    }

    if (options.onOut) {
        google.maps.event.addDomListener(
            marker,
            "mouseout",
            function () {
                options.onOut(this);
            }
        );
    }

    if (options.mapId) {
        mapMarkers[options.mapId].push(marker);
        mapMarkerBounds[options.mapId].extend(options.location);
    }
}

export interface IAddMarkersOptions {
    map     : google.maps.Map;
    mapId   : string;
    markers : google.maps.Marker[];
}

export function addMarkers(options:IAddMarkersOptions) {
    $.each(options.markers, function (idx:number, marker:google.maps.Marker) {
        marker.setMap(options.map);
        mapMarkers[options.mapId].push(marker);
        mapMarkerBounds[options.mapId].extend(marker.getPosition());
    });
}

export function clearMarkers(mapId:string) {
    $.each(mapMarkers[mapId], function (idx:number, marker:google.maps.Marker) {
        marker.setMap(null);
    });
    mapMarkers[mapId] = [];
}

export interface IZoomToFitOptions {
    map     : google.maps.Map;
    mapId   : string;
}

export function zoomToFit(options:IZoomToFitOptions) {
    var bounds:google.maps.LatLngBounds = mapMarkerBounds[options.mapId];
    var markers:google.maps.Marker[] = mapMarkers[options.mapId];

    if (markers.length == 1) {
        options.map.setCenter(bounds.getCenter());
        options.map.setZoom(mapOptions[options.mapId].zoom);
        console.log("map.setZoom " + mapOptions[options.mapId].zoom);
    } else if (markers.length > 1) {
        options.map.fitBounds(bounds);
    }
}

export interface IZoomToFitMarkersOptions {
    map: google.maps.Map;
    mapId: string;
    markers: google.maps.Marker[];
}

export function zoomToFitBounds(map:google.maps.Map, bounds:google.maps.LatLngBounds) {
    map.fitBounds(bounds);
}

export interface IAddClusteringOptions {
    map: google.maps.Map;
    mapId: string;
}

export function addClustering(options:IAddClusteringOptions) : any {
    var markers:google.maps.Marker[] = mapMarkers[options.mapId];

    console.log("addClustering " + markers.length);

    if (markers.length > 1) {
        var mc = new MarkerClusterer(
            options.map,
            markers,
            { imagePath: "/Content/Images/google-maps-markercluster" }
        );
        console.log(mc);

        return mc;
    }

    return null;
}